var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysWallet = function SvgSysWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2Zm0-2c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Z",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M16.372 7.694H7.388C6.62 7.694 6 8.237 6 8.907v6.88C6 16.456 6.621 17 7.388 17h8.984c.767 0 1.388-.544 1.388-1.214V8.907c0-.67-.621-1.213-1.388-1.213Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.561 12.879c.344 0 .623-.238.623-.532 0-.294-.279-.532-.623-.532s-.623.238-.623.532c0 .294.28.532.623.532Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m6.878 7.776 6.404-2.52c.52-.195 1.08-.463 1.29 0L15.86 7.51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M13.56 10.633h4.2v3.428h-4.2c-.52 0-1.018-.18-1.386-.502a1.613 1.613 0 0 1-.574-1.212c0-.455.207-.89.574-1.212a2.111 2.111 0 0 1 1.386-.502Z"
  })));
};
export default SvgSysWallet;